import React from 'react';

/**
 * Galeria visual abaixo dos depoimentos.
 * Usa fotos/imagens já presentes no projeto como placeholder.
 * Para trocar por fotos reais, basta substituir as URLs em GALLERY_ITEMS.
 */
const GALLERY_ITEMS = [
  {
    src: 'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/8t4q544f_01.png',
    alt: 'Adeilson Chagas — Endorsee oficial Behringer no estande WING',
    caption: 'WING Summit',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/rq3u2aex_2.png',
    alt: 'Equipe WING Academy e parceiros ProShows/Midas em evento oficial',
    caption: 'Parceria ProShows & Behringer',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/n4xer98t_3.png',
    alt: 'Equipe WING Academy no SemanÁudio',
    caption: 'Bastidores SemanÁudio',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/3tnvrn73_08.png',
    alt: 'Profissionais testando a Console WING em evento ao vivo',
    caption: 'Hands-on com a WING',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/t6bwqoj5_09.png',
    alt: 'Turma completa de alunos da WING Academy Brasil em treinamento presencial',
    caption: 'WING Summit Rio de Janeiro',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/g5at7oe1_Semanauio%202.png',
    alt: 'Adeilson Chagas no estande oficial Behringer/Midas durante o SemanÁudio',
    caption: 'SemanÁudio — Estande Oficial',
  },
];

const Gallery = () => {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="py-14 md:py-20 section-padding relative"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4">
            Nossa <span className="gradient-text">Comunidade</span>
          </h2>
          <p className="text-base md:text-xl text-gray-400 max-w-2xl mx-auto">
            Momentos reais de profissionais que dominam a Console WING na prática.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3 md:gap-4 max-w-5xl mx-auto">
          {GALLERY_ITEMS.map((item, idx) => (
            <figure
              key={item.src}
              data-testid={`gallery-item-${idx}`}
              className="group relative overflow-hidden rounded-xl md:rounded-2xl aspect-square bg-white/5 border border-white/10"
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-80 md:opacity-70 group-hover:opacity-95 transition-opacity duration-300" />
              {/* Caption */}
              <figcaption className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <span className="text-white text-xs sm:text-sm md:text-base font-semibold leading-tight line-clamp-2">
                  {item.caption}
                </span>
              </figcaption>
              {/* Yellow accent on hover */}
              <span className="pointer-events-none absolute inset-0 ring-2 ring-yellow-400/0 group-hover:ring-yellow-400/70 rounded-xl md:rounded-2xl transition-all duration-300" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
